module.exports = __webpack_public_path__ + "static/media/47.ed14940c.png";